import axios from "axios";

import * as actions from "./actionCreators";
import DatacodeConfig from "../../../core/config";
import * as constants from "../constants";
import { generateQueryParams } from "../../../utils";

const baseURL = DatacodeConfig.baseURL; 

//quiz test apis
export const createQuizTest = (quizTest) => async (dispatch) => {
  dispatch({ type: constants.CREATE_TEST_LOADING });
  return axios
    .post(`${baseURL}/quiz/test/create`, quizTest)
    .then((res) => {
      if (res.status === 200) {
        dispatch({ type: constants.CREATE_TEST_LOADING });
        return { success: true, data: res.data };
      } else {
        return { success: false };
      }
    })
    .catch((error) => {
      console.log("Create Test Error", error);
    });
};

export const getQuizTestsList = (filters = {}) => async (dispatch) => {
  dispatch({ type: constants.GET_QUIZ_TEST_LIST_LOADING });

  return axios
    .get(`${baseURL}/quiz/test${generateQueryParams({ ...filters })}`)
    .then(({ data }) => {
      if (data.success) {
        dispatch({ type: constants.GET_QUIZ_TEST_LIST_LOADING });
        dispatch(actions.setQuizTestsList(data));
        return { success: true, data: data.quizTests };
      }
    })
    .catch((error) => {
      console.log("get quiz tests error", error);
    });
};

export const deleteQuizTest = (quizTest) => async (dispatch) => {
  dispatch({ type: constants.DELETE_LOADING });
  return axios
    .delete(`${baseURL}/quiz/test/${quizTest}`)
    .then(({ data }) => {
      if (data.success) {
        dispatch({ type: constants.DELETE_LOADING });
        dispatch(actions.setQuizTestsList(data));
        return { success: true };
      }
    })
    .catch((error) => {
      console.log("Error in deleting test", error);
    });
};

export const EditQuizTest = (data) => async (dispatch) => {
  dispatch({ type: constants.GET_TEST_DATA_LOADING });
  return axios
    .patch(`${baseURL}/quiz/test/${data.quizTest}`, { data: data })
    .then(({ data }) => {
      if (data) {
        dispatch({ type: constants.GET_TEST_DATA_LOADING });
        dispatch(actions.setQuizTestDetails(data));
        return { success: true };
      }
    })
    .catch((error) => {
      console.log("Error in Edit", error);
    });
};

//test details api
export const getQuizTestDetails =
  ({ quizTest, mode }) =>
    async (dispatch) => {
      dispatch({ type: constants.GET_TEST_DATA_LOADING });
      return axios
        .get(`${baseURL}/quiz/test/${quizTest}${generateQueryParams({ mode })}`)
        .then(({ data }) => {
          if (data.success) {
            dispatch({ type: constants.GET_TEST_DATA_LOADING });
            dispatch(actions.setQuizTestDetails(data));
            return { success: true, data: data };
          }
        })
        .catch((error) => {
          console.log("get quiz tests error", error);
        });
    };

export const getTestTakens = (quizTest) => async (dispatch) => {
  dispatch({ type: constants.GET_TEST_TAKEN_LOADING });
  return axios
    .get(
      `${baseURL}/quiz/reports/${generateQueryParams({ quizTest: quizTest })}`,
    )
    .then(({ data }) => {
      if (data.success) {
        dispatch({ type: constants.GET_TEST_TAKEN_LOADING });
        dispatch(actions.setQuizOverviewTestTaken(data));
        return { success: true, data: data };
      }
    })
    .catch((error) => {
      console.log("get quiz tests taken error", error);
    });
};

//multiple reports of user
export const getTestsTakenByUser = (userId) => async (dispatch) => {
  dispatch({ type: constants.GET_TEST_TAKEN_BY_USER_LOADING });
  return axios
    .get(`${baseURL}/quiz/reports${generateQueryParams({ id: userId })}`)
    .then(({ data }) => {
      if (data.success) {
        dispatch({ type: constants.GET_TEST_TAKEN_BY_USER_LOADING });
        dispatch(actions.setReportsOfUser(data));
        return { success: true, data: data };
      }
    })
    .catch((error) => {
      console.log("get quiz tests taken error", error);
    });
};

//single report of the user
export const getTestTakenByUser =
  ({ userId, quizTest }) =>
    async (dispatch) => {
      dispatch({ type: constants.GET_TEST_TAKEN_BY_USER_LOADING });
      return axios
        .get(
          `${baseURL}/quiz/reports${generateQueryParams({
            user: userId,
            quizTest,
          })}`,
        )
        .then(({ data }) => {
          if (data.success) {
            dispatch({ type: constants.GET_TEST_TAKEN_BY_USER_LOADING });
            return { success: true, data: data };
          }
        })
        .catch((error) => {
          console.log("get quiz tests taken error", error);
        });
    };

//Candidate report review api
export const getCandidateReviewReport = (id) => async (dispatch) => {
  dispatch({ type: constants.GET_CANDIDATE_DETAILS_LOADING });
  return axios
    .get(`${baseURL}/quiz/test/report/${id}`)
    .then((res) => {
      if (res.status === 200) {
        dispatch({ type: constants.GET_CANDIDATE_DETAILS_LOADING });
        dispatch(actions.setReportReviewDetails(res.data));
        return { success: true, data: res.data };
      }
    })
    .catch((error) => {
      console.log("get quiz tests taken error", error);
    });
};

//quiz test question apis
export const createQuizQuestion = (question) => async (dispatch) => {
  dispatch({ type: constants.CREATE_QUESTION_LOADING });
  return axios
    .post(`${baseURL}/dayscode/quiz/create`, question)
    .then((res) => {
      if (res.status === 200) {
        dispatch({ type: constants.CREATE_QUESTION_LOADING });
        return { success: true };
      } else {
        return { success: false };
      }
    })
    .catch((error) => {
      console.log("Add Question Error", error);
    });
};

export const getQuizQuestionsList = (quizTest) => async (dispatch) => {
  dispatch({ type: constants.GET_TEST_DATA_LOADING });
  console.log("loading");
  return axios
    .get(
      `${baseURL}/dayscode/quiz${generateQueryParams({
        quizTest: quizTest,
      })}`,
    )
    .then(({ data }) => {
      if (data.success) {
        dispatch({ type: constants.GET_TEST_DATA_LOADING });
        dispatch(actions.setTestQuizQuestions(data));
        console.log("loaded");
        return { success: true, data: data };
      }
    })
    .catch((error) => {
      console.log("getting quiz questions error", error);
    });
};

export const getQuizQuestionDetails = (id) => async (dispatch) => {
  return axios
    .get(`${baseURL}/dayscode/quiz/${id}`)
    .then(({ data }) => {
      if (data.success) {
        dispatch(actions.setQuestionDetail(data));
        return { success: true, data: data };
      }
    })
    .catch((error) => {
      console.log("get quiz test details error", error);
    });
};

export const deleteQuizQuestion = (id) => async (dispatch) => {
  dispatch({ type: constants.DELETE_LOADING });
  return axios
    .delete(
      `${baseURL}/dayscode/quiz/${id}${generateQueryParams({
        quizTest: id,
      })}`,
    )
    .then((res) => {
      if (res.status === 200) {
        dispatch({ type: constants.DELETE_LOADING });
        return { success: true };
      }
    })
    .catch((error) => {
      console.log("Error in deleting question", error);
    });
};

export const editQuizQuestion = (formdata) => async (dispatch) => {
  return axios
    .patch(`${baseURL}/dayscode/quiz/${formdata._id}`, { data: formdata })
    .then((res) => {
      if (res.status === 200) {
        dispatch(actions.setQuestionDetail(res.data));
        return { success: true, data: res.data };
      }
    })
    .catch((error) => {
      console.log("Error in editing question", error);
    });
};

//submit test
export const submitQuizTest = (quizTest) => async (dispatch) => {
  dispatch({ type: constants.SUBMITTING_QUIZ_TEST_LOADING });
  return axios
    .post(`${baseURL}/quiz/test/${quizTest.quizTestId}/submit`, quizTest)
    .then((res) => {
      if (res.status === 200) {
        dispatch({ type: constants.SUBMITTING_QUIZ_TEST_LOADING });
        dispatch(actions.setReportDetail(res.data));
        return { success: true, data: res.data };
      } else {
        return { success: false };
      }
    })
    .catch((error) => {
      console.log("Create Test Error", error);
    });
};

export const getQuizTestsLeaderboard = () => async (dispatch) => {
  dispatch({ type: constants.GET_QUIZ_TEST_LEADERBOARD_LOADING });
  return axios
    .get(`${baseURL}/quiz/leaderboard`)
    .then(({ data }) => {
      if (data.success) {
        dispatch({ type: constants.GET_QUIZ_TEST_LEADERBOARD_LOADING });
        dispatch(actions.setQuizTestsLeaderboard(data));
        return { success: true, data: data.leaderboard ,completedTestsCount: data.completedTestsCount,totalFailed: data.totalFailed,totalPassed: data.totalPassed};
      }
    })
    .catch((error) => {
      console.log("get quiz tests leaderboard error", error);
    });
};

//details for certificates api
export const getQuizTestCertificates = () => async (dispatch) => {
  dispatch({ type: constants.GET_QUIZ_TEST_CERTIFICATES_LOADING });
  return axios
    .get(`${baseURL}/quiz/certificates`)
    .then(({ data }) => {
      if (data.success) {
        dispatch({ type: constants.GET_QUIZ_TEST_CERTIFICATES_LOADING });
        dispatch(actions.setQuizTestsCertificates(data));
        return { success: true, data: data.totalCertificates };
      }
    })
    .catch((error) => {
      console.log("get quiz tests certificates error", error);
    });
};



//  login user Details
export const getLoginUserDetail = () => async (dispatch) => {
  dispatch({ type: constants.GET_LOGIN_USER_DETAILS });
  return axios
    .post(`${baseURL}/dayscode/quiz/login`)
    .then((res) => {
      console.log("Response status:", res.status); // Log the status code
      if (res.status === 200) {
        dispatch({ type: constants.GET_LOGIN_USER_DETAILS });
        return { success: true, data: res.data };
      } else {
        console.log("Failed login response:", res.data); // Log the failed response data
        return { success: false };
      }
    })
    .catch((error) => {
      console.log(
        "API error:",
        error.response ? error.response.data : error.message,
      );
      return { success: false }; // Ensure false is returned on error
    });
};

//Request Invite for Quiz
export const requestQuizInviteByCandidate = (inviteCandidate) => (dispatch) => {
  dispatch({ type: constants.SUBMITTING_INVITE_FORM_LOADING });
  return axios
    .post(`${baseURL}/quiz/invite/create`, inviteCandidate)
    .then((res) => {
      if (res.status === 201) {
        dispatch({ type: constants.SUBMITTING_INVITE_FORM_LOADING });
        return { success: true, data: res?.data };
      } else {
        return { success: false };
      }
    })
    .catch((error) => {
      dispatch({ type: constants.SUBMITTING_INVITE_FORM_LOADING });
      console.log("Create Test Error", error);
      // triggerNotifier({
      //   message: "Mentor availabilties Error",
      //   type: "error",
      //   duration: 1000,
      //   icon: "⚠️",
      // });
    });
};